'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
* Tencent is pleased to support the open source community by making SPA UI available.
* Copyright (C) 2019, a Tencent company. All rights reserved.
*/
var LOCALE = exports.LOCALE = {
    Monday: '星期一',
    Tuesday: '星期二',
    Wednesday: '星期三',
    Thursday: '星期四',
    Friday: '星期五',
    Saturday: '星期六',
    Sunday: '星期日',
    week: '星期',
    time: '时间',
    unselected: '未选',
    selected: '已选',
    operationTip: '可拖动鼠标选择时间段',
    empty: '清空'
};

var weekDayNames = exports.weekDayNames = [LOCALE.Monday, LOCALE.Tuesday, LOCALE.Wednesday, LOCALE.Thursday, LOCALE.Friday, LOCALE.Saturday, LOCALE.Sunday];

/**
 * 状态类型定义
 * @type {object}
 * @examplet
 * {SELECTED: number, UNSELECTED: number}
 */
var SELECT_STATUS = exports.SELECT_STATUS = {
    SELECTED: 1,
    UNSELECTED: 0
};

exports.default = {
    LOCALE: LOCALE,
    SELECT_STATUS: SELECT_STATUS,
    weekDayNames: weekDayNames
};